import {
  SET_DIMENSIONS,
  SET_DIMENSION_POLICY_DATA,
  UPDATE_DIMENSION_FORM_ERROR,
  RESET_DIMENSION_POLICY_DATA,
  DIMENSION_MEMBERS_DATA,
  SET_HIERARCHIES,
  SET_DIMENSIONS_PAGE_DATA,
  RESET_DIMENSION_MEMBER_DATA,
  PAGINATED_DIMENSION_MEMBERS,
  DIMENSION_ATTRIBUTES,
  ADD_DIMENSION_ATTRIBUTE
} from "./types";
import { IAttribute } from "../../../models/Policies/PolicyContract"
export const setDimensions = (value: any) => {
  return {
    type: SET_DIMENSIONS,
    data: {
      dimensions: value
    }
  };
}
export const setDimensionAttributes = (value: any) => {
  return {
    type: DIMENSION_ATTRIBUTES,
    data: {
      attributes: value
    }
  };
}
export const addDimensionAttribute = (attribute: IAttribute) => {
  return {
    type: ADD_DIMENSION_ATTRIBUTE,
    attributes: attribute
  }
}
export const setDimensionPolicyData = (name: string, value: any) => {
  return {
    type: SET_DIMENSION_POLICY_DATA,
    data: {
      [name]: value
    }
  }
};
export const updateDimensionFormError = (name: string, value: string) => {
  return {
    type: UPDATE_DIMENSION_FORM_ERROR,
    data: { [name]: value }
  }
};
export const resetDimensionPolicyData = () => {
  return {
    type: RESET_DIMENSION_POLICY_DATA
  }
};
export const setDimensionsMembersData = (data: {}) => {
  return {
    type: DIMENSION_MEMBERS_DATA,
    data
  }
};
export const setPaginatedDimensionMembers = (members: any, level: string) => {
  return {
    type: PAGINATED_DIMENSION_MEMBERS,
    data: { members, level }
  }
};
export const setDimensionsPageData = (page: {}, level: string) => {
  return {
    type: SET_DIMENSIONS_PAGE_DATA,
    data: { page, level }
  }
}
export const setHierarchiesData = (name: string, hierarchyId: string, value: any) => {
  return {
    type: SET_HIERARCHIES,
    data: { id: hierarchyId, value, name }
  }
};
export const resetDimensionMemberData = (level: any) => {
  return {
    type: RESET_DIMENSION_MEMBER_DATA,
    data: { level }
  }
}